/* eslint-disable */

import React, { Component } from 'react';
import {
  Button,
  Dropdown,
  Divider,
  Grid,
  Container,
  Loader,
  TextArea
} from 'semantic-ui-react';
import _ from 'lodash';

import { getAccount } from '../../fbApi/Account';
import { getAccounts } from '../../services/AccountService';
import { getCampaign, getCampaigns } from '../../fbApi/Campaign';
import { getCanvas } from '../../fbApi/Canvas';
import { creds } from '../../config/FBAdOps';
import { getPage } from '../../fbApi/Page';
import * as AdBlueprintDB from '../../database/AdBlueprintDB';
import { getRawAdName } from '../../utils/ad.common';
import { getCarousels } from '../../services/CarouselService';
import months from '../../utils/months';
import {
  replaceUrlsInCanvas,
  createCanvasAd,
  replaceValuesInAdBlueprint,
  replaceUrlsInCarousel,
  createCarouselAd
} from './AdCreator';
import {
  getCanvasData,
  launchCanvasToFacebook
} from '../Canvas/CanvasLauncher';
import './AdBuilderV2.css';

class AdBuilderV2 extends Component {
  state = {
    token: this.props.getFbToken(),
    accountOptions: null,
    adTypes: [],
    adBlueprints: [],
    adBlueprintOptions: [],
    errorMessage: '',
    data: null,
    selectedCampaigns: [],
    showCampaignsLoader: false,
    years: [],
    months: [],
    canvases: [],
    carousels: [],
    logText: '',
    processing: false,
    showCampaignSelector: false,
    campaignFormats: {
      PRODUCT_CATALOG_SALES: 'Dynamic Ads',
      LEAD_GENERATION: 'Lead Ads',
      VIDEO_VIEWS: 'Video Ads',
      LINK_CLICKS: 'Traffic Ads',
      CONVERSIONS: 'Engagement Ads',
      OUTCOME_TRAFFIC: 'Outcome Traffic',
      OUTCOME_SALES: 'Outcome Sales'
    },
    campaignsFilterFormats: {},
    form: {
      selectedAccount: '',
      selectedAdType: '',
      selectedAdBlueprint: '',
      selectedYear: '',
      selectedMonth: ''
    }
  };

  componentDidMount() {
    this.props.setSectionTitle('Ad Builder V2');
    this.props.saveGTMEvent('Ad Builder V2', 'Ad Builder V2');
    this.getAdAccounts();
    this.getCanvases();
    this.getCarousels();
  }

  getCarousels = async () => {
    const carousels = await getCarousels();
    this.setState({ carousels: carousels.carousels });
  };

  getCanvases = async () => {
    const canvases = await AdBlueprintDB.getCanvases();
    this.setState({ canvases });
  };

  onAccountSelect = async (event, data) => {
    const account = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    const accountId = account.value;
    this.getCampaigns(accountId);
    const form = this.state.form;
    form.selectedAccount = accountId;
    form.selectedYear = '';
    form.selectedMonth = '';
    form.selectedAdType = '';
    form.selectedAdBlueprint = '';
    const adBlueprintList = await AdBlueprintDB.getAdBlueprintByAccountId(
      accountId
    );
    const adTypes = [];
    let key = 0;

    adBlueprintList.forEach((adBlueprint) => {
      const existAdType = adTypes.find(
        (type) => type.value === adBlueprint.adType
      );
      if (!existAdType) {
        adTypes.push({
          key,
          value: adBlueprint.adType,
          text: adBlueprint.adType
        });
        key += 1;
      }
    });

    form.selectedAccount = accountId;

    this.setState({
      form,
      adTypes,
      adBlueprints: adBlueprintList,
      showCampaignSelector: false,
      adBlueprintOptions: [],
      filteredMonths: []
    });
  };

  getCampaigns = async (accountId) => {
    const campaigns = await getCampaigns(accountId, this.state.token);
    const result = campaigns.data;

    const assocCampaigns = [];
    const campaignMonths = [];
    const years = [];

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);
      assocCampaigns[year + month] = {
        month_year: null,
        ids: []
      };
    });

    _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
      const firstPart = campaign.name.split('_')[0];
      const year =
        firstPart.length === 4
          ? firstPart
          : firstPart.substring(firstPart.length - 4, firstPart.length);
      const month =
        firstPart.length === 4
          ? campaign.name.split('_')[1]
          : firstPart.substring(0, firstPart.length - 4);

      const existentYear = years.filter((item) => {
        return item.text === year;
      });

      if (existentYear.length === 0) {
        years.push({
          value: year,
          text: year
        });
      }

      assocCampaigns[year + month].month = month;
      assocCampaigns[year + month].year = year;
      assocCampaigns[year + month].ids.push(campaign.id);
    });

    _.mapKeys(assocCampaigns, (month) => {
      if (month) {
        campaignMonths.push(month);
      }
    });

    const campaignOptions = _.map(campaignMonths, (op, index) => {
      const month = months.filter((item) => {
        return item.shortName === op.month;
      });

      return {
        key: index,
        value: op.ids.join(','),
        text: month[0] ? month[0].monthName : op.month,
        accountId,
        year: op.year
      };
    });

    const monthsOpt = _.map(campaignOptions, (op) => {
      return {
        value: op.text,
        text: op.text,
        campaignsIds: op.value,
        year: op.year
      };
    });

    const filteredMonths = monthsOpt.filter(
      (m) => m.year === this.state.form.selectedYear
    );

    this.setState({
      selectedCampaigns: campaignOptions,
      filteredCampaigns: campaignOptions,
      years,
      months: monthsOpt,
      campaigns: campaignOptions
    });
  };

  fillAdBlueprints = async (adType) => {
    const adBlueprintList = this.state.adBlueprints.filter(
      (adBlueprint) => adBlueprint.adType === adType
    );
    const adBlueprintOptions = _.sortBy(
      _.map(adBlueprintList, (op, index) => ({
        key: index,
        value: op.id,
        text: op.name
      })),
      'text'
    );

    this.setState({ adBlueprintOptions });
  };

  onTypeSelect = (event, data) => {
    const form = this.state.form;
    form.selectedAdType = data.value;

    this.fillAdBlueprints(data.value);

    this.setState({ form });
  };

  onAdBlueprintSelect = (event, data) => {
    const form = this.state.form;
    form.selectedAdBlueprint = data.value;

    this.setState({ form });
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        accountOptions
      });
    } catch (error) {
      alert(error);
    }
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    const filteredCampaigns = this.state.campaigns.filter((val) => {
      return val.year === value;
    });

    const filteredMonths = this.state.months.filter((m) => m.year === value);
    const form = this.state.form;
    form.selectedYear = value;

    this.setState({
      filteredCampaigns,
      form,
      filteredMonths,
      showCampaignSelector: false
    });
  };

  renderCampaingDropdownFilters = () => {
    if (this.state.showCampaignSelector) {
      const formats = this.state.campaignsFilterFormats.formats;
      const columnCount = formats.length;
      return (
        <Grid columns={columnCount}>
          <Grid.Row>
            {formats.map((f) => this.renderFormatDropdown(f))}
          </Grid.Row>
        </Grid>
      );
    } else if (this.state.showCampaignsLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }

    return null;
  };

  renderFormatDropdown = (format) => {
    if (format.adsets.length === 0) {
      return;
    }

    const options = format.adsets.map((adset) => {
      return {
        key: adset.id,
        value: adset.id,
        text: adset.name
      };
    });

    return (
      <Grid.Column>
        <span>{format.campaingName}</span>
        <div style={{ maxWidth: 300 }} className="flipper-campaign-filter">
          <Dropdown
            placeholder={format.campaingName}
            value={this.mapSelectedValues(format)}
            onChange={(event, data) =>
              this.handleFilterChange(
                event,
                data.value,
                format.campaignid,
                true
              )
            }
            onLabelClick={(event, data) =>
              this.handleFilterChange(
                event,
                [data.value],
                format.campaignid,
                false
              )
            }
            disabled={this.state.processing}
            fluid
            multiple
            search
            selection
            options={options}
          />
        </div>
      </Grid.Column>
    );
  };

  handleFilterChange = (event, adsetids, campaignId, isChange) => {
    const formats = this.state.campaignsFilterFormats.formats;
    adsetids.forEach((adsetid) => {
      const campaignObj = formats.filter((c) => {
        return c.campaignid === campaignId;
      })[0];
      const adsetObj = campaignObj.adsets.filter((adset) => {
        return adset.id === adsetid;
      })[0];
      adsetObj.selected = isChange;
    });

    const validCampaignSelection =
      formats.filter((f) => f.adsets.filter((a) => a.selected).length > 0)
        .length > 0;
    this.setState({
      campaignsFilterFormats: {
        formats
      },
      validCampaignSelection
    });
  };

  mapSelectedValues = (format) => {
    const selected = format.adsets
      .filter((adset) => {
        return adset.selected;
      })
      .map((adset) => {
        return adset.id;
      });

    return selected;
  };

  onCampaignSelect = async (event, data) => {
    const selectedMonth = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    this.selectMonth(null, selectedMonth);
  };

  selectMonth = async (month, selectedMonth) => {
    const form = this.state.form;
    form.selectedMonth = selectedMonth;
    this.setState({ form, showCampaignsLoader: true });

    await this.getCampaigns(this.state.form.selectedAccount);
    let campaign = _.find(this.state.selectedCampaigns, (option) => {
      return option.value.indexOf(selectedMonth.campaignsIds) !== -1;
    });

    campaign = month ? month : campaign;

    const token = this.props.getFbToken();
    await this.getCampaignForMonth(campaign.value.split(','), token);

    this.setState({
      showCampaignSelector: true,
      showCampaignsLoader: false,
      campaignName: campaign.text,
      campaignIds: campaign.value,
      formatSelected: null
    });
  };

  getCampaignForMonth = async (campaignIds, token) => {
    const campaingDropdowns = {
      formats: []
    };

    this.setState({
      showCampaignsLoader: true,
      showCampaignSelector: false
    });
    const allCampaigns = await Promise.all(
      _.map(campaignIds, async (campaignId) => {
        const campaign = await getCampaign(campaignId, token);

        const campAdsets = campaign.adsets
          ? await campaign.adsets.data.map((adset) => {
              return {
                name: getRawAdName(adset.name),
                id: adset.id,
                selected: false,
                campaignId: campaign.id
              };
            })
          : [];

        campaingDropdowns.formats.push({
          campaingName: this.state.campaignFormats[campaign.objective],
          campaignid: campaignId,
          adsets: campAdsets
        });

        const campaignToReport = {
          value: campaign.id,
          text: this.state.campaignFormats[campaign.objective],
          name: campaign.name
        };

        return Promise.resolve(campaignToReport);
      })
    );

    this.setState({
      allCampaigns,
      campaignsFilterFormats: campaingDropdowns
    });
  };

  getSelectedAdSets = () => {
    let selectedAdSets = [];
    if (this.state.campaignsFilterFormats.formats) {
      this.state.campaignsFilterFormats.formats.map((format) => {
        format.adsets.map((adset) => {
          if (adset.selected) {
            selectedAdSets.push(adset);
          }
        });
      });
    }

    return selectedAdSets;
  };

  validFields = () => {
    const selectedAdSets = this.getSelectedAdSets();
    return selectedAdSets.length > 0 && this.state.form.selectedAdBlueprint;
  };

  launchCanvas = async (canvas, page) => {
    const parameters = {
      canvasId: canvas.id,
      pageId: page.id,
      token: page.access_token,
      is_published: true
    };

    try {
      const result = await launchCanvasToFacebook(parameters, canvas);
      return result.result;
    } catch (error) {
      return null;
    }
  };

  buildAds = async () => {
    this.setState({ errorMessage: '' });

    if (!this.validFields()) {
      this.setState({
        errorMessage: 'You must select an ad bluprint and adset'
      });
      return;
    }

    this.setState({ processing: true, logText: '' });

    const adBlueprint = this.state.adBlueprints.find(
      (adBlueprint) => adBlueprint.id === this.state.form.selectedAdBlueprint
    );
    const page = await getPage(adBlueprint.page, this.state.token);
    const accountData = await getAccount(
      adBlueprint.adAccount,
      this.state.token
    );
    let pixel = '';

    if (accountData && accountData.adspixels && accountData.adspixels.data[0]) {
      pixel = accountData.adspixels.data[0].id;
    }

    switch (true) {
      case adBlueprint.adType === 'Canvas':
        const resultCanvas = await this.launchCanvasAds(
          adBlueprint,
          page,
          pixel
        );
        break;
      case adBlueprint.adType === 'Carousel':
        const resultCarousel = await this.launchCarouselAds(
          adBlueprint,
          page,
          pixel
        );
        break;
      default:
        break;
    }

    this.setState({ processing: false });
  };

  launchCarouselAds = async (adBlueprint, page, pixel) => {
    const carousel = this.state.carousels.find(
      (item) => item.id === adBlueprint.carouselId
    );
    const urlValues = JSON.parse(adBlueprint.urlValues);
    const newCarousel = replaceUrlsInCarousel(urlValues, carousel);
    const selectedAdSets = this.getSelectedAdSets();

    const parameters = {
      adBlueprint,
      cards: newCarousel.cards,
      displayLink: newCarousel.displayLink,
      body: newCarousel.body,
      status: 'ACTIVE',
      urlTags:
        'utm_source=Facebook&utm_campaign=Constellation&utm_content={‌{adset.name‌‌}‌}&utm_medium=Carousel-{‌{site_source_name}‌}-{‌{placement}‌}&utm_term={‌{ad.name}‌}',
      pixel,
      token: this.state.token
    };

    await Promise.all(
      selectedAdSets.map(async (adSet) => {
        parameters.adSetId = adSet.id;
        const shortMonth = this.state.form.selectedMonth.value.substring(0, 3);
        parameters.name =
          this.state.form.selectedYear +
          '_' +
          shortMonth +
          '_' +
          adSet.name +
          '_' +
          adBlueprint.adType +
          '_' +
          adBlueprint.name;
        const resultAd = await createCarouselAd(parameters);

        if (resultAd.id) {
          this.setState({
            logText:
              this.state.logText +
              'Ad: ' +
              adBlueprint.name +
              ' CREATED in Adset ' +
              adSet.name +
              '\n'
          });
        } else {
          this.setState({
            logText:
              this.state.logText +
              'Ad: ' +
              adBlueprint.name +
              ' ERROR in Adset ' +
              adSet.name +
              ' - ' +
              resultAd.error.error_user_title +
              resultAd.error.message +
              '\n'
          });
        }

        return Promise.resolve(resultAd);
      })
    );
  };

  launchCanvasAds = async (adBlueprint, page, pixel) => {
    let canvasData = getCanvasData(adBlueprint.canvasId, this.state.canvases);
    const urlValues = JSON.parse(adBlueprint.urlValues);
    replaceUrlsInCanvas(urlValues, canvasData);
    const newAdBlueprint = replaceValuesInAdBlueprint(urlValues, adBlueprint);

    const canvasId = await this.launchCanvas(canvasData, page);

    if (canvasId) {
      this.setState({
        logText:
          this.state.logText +
          'Canvas: ' +
          canvasData[0].name +
          ' CREATED' +
          '\n'
      });
    } else {
      this.setState({
        logText:
          this.state.logText +
          'Canvas: ' +
          canvasData[0].name +
          ' ERROR: There was an error launching the canvas' +
          '\n'
      });
    }

    const canvas = await getCanvas(canvasId, this.state.token);
    const selectedAdSets = this.getSelectedAdSets();

    const parameters = {
      adBlueprint: newAdBlueprint,
      status: 'ACTIVE',
      urlTags:
        'utm_source=Facebook&utm_campaign=Constellation&utm_content={{adset.name}}&utm_medium=Canvas-{{site_source_name}}-{{placement}}&utm_term={{ad.name}}',
      pixel,
      canvasUrl: canvas.canvas_link,
      token: this.state.token
    };

    await Promise.all(
      selectedAdSets.map(async (adSet) => {
        parameters.adSetId = adSet.id;
        const shortMonth = this.state.form.selectedMonth.value.substring(0, 3);
        parameters.name =
          this.state.form.selectedYear +
          '_' +
          shortMonth +
          '_' +
          adSet.name +
          '_' +
          adBlueprint.adType +
          '_' +
          adBlueprint.name;
        const resultAd = await createCanvasAd(parameters);

        if (resultAd.id) {
          this.setState({
            logText:
              this.state.logText +
              'Ad: ' +
              adBlueprint.name +
              ' CREATED in Adset ' +
              adSet.name +
              '\n'
          });
        } else {
          this.setState({
            logText:
              this.state.logText +
              'Ad: ' +
              adBlueprint.name +
              ' ERROR in Adset ' +
              adSet.name +
              ' - ' +
              resultAd.error.error_user_title +
              resultAd.error.message +
              '\n'
          });
        }

        return Promise.resolve(resultAd);
      })
    );
  };

  render() {
    return (
      <div className="form-container">
        <Grid>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Dropdown
                className="field-accounts"
                placeholder="Ad Accounts"
                search
                selection
                options={this.state.accountOptions}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              <Dropdown
                className="field-accounts"
                placeholder="Ad Types"
                search
                selection
                options={this.state.adTypes}
                onChange={this.onTypeSelect}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                className="field-accounts"
                placeholder="Ad Blueprints"
                search
                selection
                options={this.state.adBlueprintOptions}
                onChange={this.onAdBlueprintSelect}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                placeholder="Year"
                search
                selection
                value={this.state.form.selectedYear}
                options={this.state.years}
                onChange={this.onYearSelect}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Month"
                search
                selection
                value={this.state.form.selectedMonth.value}
                options={this.state.filteredMonths}
                onChange={this.onCampaignSelect}
              />
            </Grid.Column>
            <Grid.Column>
              <Button
                className="floated left tiny grey"
                onClick={() => this.buildAds()}
              >
                Build
              </Button>
              {this.state.errorMessage ? (
                <div className="error-message-container">
                  <span>{this.state.errorMessage}</span>
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {this.renderCampaingDropdownFilters()}
        <Divider hidden />
        {this.state.processing ? (
          <div className="processing-container">
            <span>
              {' '}
              <Loader inline className="active" /> Processing...{' '}
            </span>
          </div>
        ) : null}
        <Divider hidden />
        <TextArea
          className="debug-log"
          placeholder="Debug Log"
          disabled
          rows="18"
          value={this.state.logText}
        />
      </div>
    );
  }
}

export default AdBuilderV2;



// WEBPACK FOOTER //
// ./src/screens/AdBuilder/AdBuilderV2.js